<app-dashboard-layout [notDashboard]="true">
    <section class="bg-white border rounded-md p-4">
      <header class="border-b flex text-lg mb-6 w-full pb-4 gap-8 md:text-xl">
        Parents/Guardians
      </header>
  
      <nav class="flex flex-col gap-4">
        <div class="grid gap-8 grid-cols-1 md:grid-cols-4">
          <div class="w-full"></div>
          <div class="w-full"></div>
          <div class="w-full"></div>
          <app-button-primary type="button" class="w-full" 
          [disabled]="loading" (click)="showGuardianList()">
            <div>SHOW LIST</div>
          </app-button-primary>
        </div>
      </nav>
      <div *ngIf="skeletonLoader" class="max-w-screen-md grid pb-4 gap-4 gap-8 grid-cols-1 md:grid-cols-2">
        <div *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8]" class="border rounded-md bg-gray-300 h-20 animate-pulse"></div>
      </div>
  
      <app-notification-alert [data]="notification"></app-notification-alert>
      <form ngNativeValidate *ngIf="!skeletonLoader" id="biodata-education" (ngSubmit)="updateGuardians()"
        class="max-w-screen-md grid gap-8 grid-cols-1">
        <div *ngFor="let x of totalGuardians(); let i = index"
          class="border-primary-lighter border-b-2 grid pb-8 gap-8 grid-cols-1">

          <app-guardian-form-fields [states]="states" [ChildLeavingWith]="ChildLeavingWith" [guardianToSave]="GuadiansDTO[i]" ></app-guardian-form-fields>

          <div>
            <app-button-primary [outline]="true" class="flex gap-4" [disabled]="loading" (click)="removeGuardian(i)">
              <div>REMOVE GUARDIAN</div>
              <div class="material-icons">delete</div>
            </app-button-primary>
          </div>
        </div>
  
        <nav class="flex flex-col py-6 gap-4">
          <div class="grid py-6 gap-8 grid-cols-1 md:grid-cols-2">
            <app-button-primary type="button" class="w-full" [outline]="true" [disabled]="loading" (click)="addGuardian()">
              <div>ADD GUARDIAN</div>
              <div class="material-icons">add</div>
            </app-button-primary>
  
            <app-button-primary type="submit" [disabled]="loading" class="w-full">
              UPDATE GUARDIANS
            </app-button-primary>
          </div>
  
          <app-notification-alert [data]="notification"></app-notification-alert>
        </nav>
      </form>
    </section>
  </app-dashboard-layout>